import React, { useState } from "react";

import { ContactUs } from "../components/contactUs";
import { ContactUsModal } from "../components/contactUsModal";
import { Helmet } from "react-helmet";
import Layout from "../components/layout";
import Seo from "gatsby-plugin-wpgraphql-seo";
import SidebarFilters from "../components/sidebarFilters";
import StackCard from "../components/card/stackCard";
import StackHeader from "../components/stackHeader";
import TrainingCardLarge from "../components/card/trainingCardLarge"
import Close from '../images/icons/closeIcon.svg'
import Filter from '../images/icons/filter.svg'
import { useLocation } from "@reach/router"
import { navigate } from "gatsby"
import { Slider } from '../components/Slider'





export function StacksTemplate({
  seoTitle,
  seoPost,
  stackPages,
  stackMenuLabels,
  currentPage,
  data,
  setSearchQuery,
  filter,
  setFilter,
  searchQuery,
  searchResultCount,
  cardsToDisplay,
  settings,
  setCategoryFilter,
  categoryFilter,
  categories
}) {
  let filterOptions = [
    { name: "Popular", slug: "popular", id: "popular" },
    { name: "Recently Added", slug: "new", id: "new" },
    { name: "Upcoming", slug: "upcoming", id: "upcoming" },
  ];
  /*if (currentPage === "training") {
    filterOptions.push({ name: "Free", slug: "free", id: "free" })
    filterOptions.push({ name: "$ Paid", slug: "paid", id: "paid"})
  }*/

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [showModal, setShowModal] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false)
  const [filterList, setFilterList] = useState([])

  const sliderCards = cardsToDisplay.filter(card => card.node.acf.tenjinHighlightCard);
  const handleClose = (value) => {
    if (params.has(value.type)) {
      params.delete(value.type);
    }
    navigate(`${location.pathname}?${params.toString()}`)
  }

  return (
    <Layout>
      <Helmet>
        <body className="trainings-page" />
      </Helmet>
      {seoPost &&
        <Seo
          title={seoTitle}
          post={seoPost}
        />
      }
      <StackHeader
        setSearchQuery={setSearchQuery}
        {...{ filter, setFilter }}
        stackPages={stackPages}
        stackMenuLabels={stackMenuLabels}
      />
      <div className="flex mx-auto mt-12 page-container lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl lg:px-0">
        <div className="hidden w-1 w-1/5 h-1 pr-1 mr-6 lg:block"></div>
        <div className="h-5 mb-2 w-full lg:w-3/4 px-6 lg:px-0">
          {searchQuery.trim().length > 0 && searchResultCount !== null && (
            <p
              className={`text-xl-v0 text-midnight-tenjin font-medium leading-5`}
            >
              Showing <span className="font-black">{searchResultCount}</span>{" "}
              {searchResultCount === 1 ? "Result" : "Results"}
            </p>
          )}
        </div>
      </div>
      <div className="mx-auto max-w-screen-2xl pb-25 md:max-w-2xl lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl">
        <div className="flex flex-row px-6 lg:px-0 lg:space-x-10">
          <SidebarFilters
            categories={categories}
            filterOptions={filterOptions}
            setCategoryFilter={setCategoryFilter}
            categoryFilter={categoryFilter}
            filter={filter}
            setFilter={setFilter}
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            filterList={filterList}
            setFilterList={setFilterList}
          />
          <div className="w-full lg:w-3/4">
            <div className="mb-5 flex flex-col">
              <div className={`flex items-center justify-between ${sliderCards.length > 0 && (currentPage === "training" || currentPage === "tutorial") && 'lg:justify-center'} space-x-2`}>
                <h1 className="font-black text-primary text-3xl text-left">
                  {stackPages[currentPage].title}
                </h1>
                <button
                  className='flex items-center justify-end ml-auto py-2 px-3 flex-shrink-0 h-10 w-max rounded-full shadow-lg text-sm text-white bg-nav-active lg:hidden cursor-pointer'
                  onClick={() => { setShowSidebar(true) }}
                >
                  <img src={Filter} alt="filter icon" className='mr-1' />
                  Filters
                </button>
              </div>
              <span className={`text-xl text-gray-500 text-left ${sliderCards.length > 0 && (currentPage === "training" || currentPage === "tutorial") && 'lg:text-center'}`} dangerouslySetInnerHTML={{ __html: stackPages[currentPage].content }} />
            </div>

            {((currentPage === "training" || currentPage === "tutorial") && sliderCards.length > 0 && filterList?.length <= 0) &&
              <div className='flex flex-row'>
                <Slider cards={sliderCards} />
              </div>
            }
            <div className='flex flex-wrap space-x-2 lg:hidden mb-5'>
              {filterList?.length > 0 && filterList.map((item) => {
                return (
                  <div className='flex items-center bg-purpleLight text-primary font-semibold px-4 py-2 rounded space-x-3 mb-2' key={item?.id}>
                    <div className='text-base leading-4 align-middle'>{item?.value}</div>
                    <button
                      onClick={() => handleClose(item)}
                    >
                      <img
                        src={Close}
                        alt="close icon"
                        className='my-auto cursor-pointer'
                      />
                    </button>
                  </div>
                )
              })}
            </div>
            {cardsToDisplay.length > 0 && (
              <>
                <div className="flex flex-col w-full space-y-20">
                  <CardList
                    data={data}
                    cards={cardsToDisplay}
                    settings={settings}
                    currentPage={currentPage}
                  />
                </div>
              </>
            )}
            <div className="mt-10">
              <ContactUs name={currentPage.replace(/s$/, '')} setShowModal={setShowModal} />
              {showModal && (
                <ContactUsModal
                  showModal={showModal}
                  setShowModal={setShowModal}
                  headline={`Are you ready to gain more insight into your marketing data?<br/><br/>
                    Book a demo with our team to get a personalized tour of our platform and take the opportunity to get a free trial using two weeks' worth of your data after the demo.<br/><br/>
                    If you cannot find a time slot that suits you here, feel free to send us an email with your availabilities at <a class='underline' href='mailto:info@growthfullstack.com'>info@growthfullstack.com</a>, and we will get back to you ASAP.`}
                  btnText="Book a Demo"
                  subject="Demo Request"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

function CardList(props) {
  return (
    <React.Fragment>
      <div
        className={`w-full gap-6 ${props.currentPage === "training" || props.currentPage === "tutorial"
          ? "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3"
          : "stack--pages__main-container-stack--layout"
          } `}
      >
        {props.cards.map((node, index) =>
          props.currentPage === "training" || props.currentPage === "tutorial" ? (
            <TrainingCardLarge
              cardData={node}
              key={index}
            />
          ) : (
            <StackCard cardData={node} cardIndex={index} key={index} />
          )
        )}
      </div>
    </React.Fragment>
  );
}
